import React from "react";
import PropTypes from 'prop-types';
import { liad_cover, liad_cover_medium, liad_cover_small } from "../assets/images/";
import { ChevronDown } from "lucide-react";
import AnimateOnScroll from '../components/AnimateOnScroll';
import Logo from '../components/Logo';
import { useLanguage } from '../providers/LanguageProvider';

const Hero = ({ id }) => {
  const { translations } = useLanguage();
  
  return (
  <header id={id} className="relative w-full overflow-hidden bg-cream">
    {/* Logo Section */}
    <div className="relative h-[110px] md:h-[130px] z-10 flex items-center justify-center">
      <div className="mx-auto max-w-[1150px] text-center">
        <AnimateOnScroll>
          <Logo variant="primary" />
        </AnimateOnScroll>
      </div>
    </div>


    {/* Hero Container */}
    <div className="relative h-[calc(100dvh-110px)] md:h-[calc(100dvh-130px)] overflow-hidden">
      {/* Background image (full-bleed) */}
      <picture>
        <source 
          media="(min-width: 1024px)" 
          srcSet={liad_cover}
          type="image/webp"
        />
        <source 
          media="(min-width: 768px)" 
          srcSet={liad_cover_medium}
          type="image/webp"
        />
        <source 
          media="(max-width: 767px)" 
          srcSet={liad_cover_small}
          type="image/webp"
        />
        <img
          src={liad_cover}
          alt="Liad Dahari - Vocal Coach"
          className="absolute inset-0 h-full w-full object-cover object-[70%] md:object-[60%_45%] animate-[zoom13_20s_linear_infinite_alternate]"
          fetchPriority="high"
        />
      </picture>
      {/* Gradient overlay to ensure readable contrast over the photo */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent" />


      {/* Content positioned lower for better readability */}
      <div className="absolute inset-0 flex items-end justify-center pb-20 md:pb-32 lg:pb-20">
        <div className="flex flex-col items-center justify-center text-white font-bold leading-normal text-center px-6 ">
          <AnimateOnScroll delay={300}>
            <div className="space-y-4 md:space-y-8">
                <h1 className="text-2xl md:text-4xl lg:text-5xl">{translations.hero.title}</h1>
                <p className="text-lg md:text-2xl lg:text-3xl max-w-4xl">{translations.hero.subtitle}</p>
            </div>
          </AnimateOnScroll>
          
          <AnimateOnScroll delay={600}>
            <div className="mt-4 md:mt-12">
              <a
                href="#contact"
                className="inline-block rounded-none bg-white px-6 py-2 text-base md:text-lg font-bold text-black transition-all duration-300 hover:bg-white/90 hover:scale-105 shadow-lg"
              >
                {translations.hero.button}
              </a>
            </div>
          </AnimateOnScroll>
        </div>
          <div className="absolute bottom-0 transform mx-auto z-20 cursor-pointer animate-bounce-slow"
          onClick={() => {
            const nextSection = document.getElementById("intro");
            if (nextSection) {
              nextSection.scrollIntoView({ behavior: "smooth" });
            }
          }}
          role="button"
          aria-label="Scroll to next section"
        >
          <ChevronDown
            className="text-white w-10 h-10 opacity-80 hover:opacity-100"
            strokeWidth={2.5}
          />
        </div>
      </div>
    </div>
  </header>
  );
};

Hero.propTypes = {
  id: PropTypes.string,
};

export default Hero;